import { render } from "./AssistantReplyBody.vue?vue&type=template&id=414a8880"
import script from "./AssistantReplyBody.vue?vue&type=script&lang=js"
export * from "./AssistantReplyBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__